import { getClassNames } from '@websolutespa/bom-core';
import { IconLlmPaperclip } from '@websolutespa/bom-mixer-icons';
import { LlmBlock, LlmChunkFile } from '../../../types';
import style from './file.module.scss';

export const File: React.FC<LlmBlock<LlmChunkFile>> = (props) => {
  const { item } = props;
  const classNames = getClassNames(style.root, 'llm__file', { [`llm__file--${item.type}`]: !!item.type });
  const title = item.url && item.url.split('/').pop()!.split('?')[0];
  return (
    <div className={classNames}>
      {item.url ? (
        <div className="llm__row">
          <div className="llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6">
            <a className={style.anchor} href={item.url} download={title} target="_blank" rel="noreferrer">
              <IconLlmPaperclip className={style.icon} /> <span>{title}</span>
            </a>
          </div>
        </div>
      ) : (
        <pre className={classNames}>{JSON.stringify(item, null, 2)}</pre>
      )}
    </div>
  );
};
